export default "__VITE_ASSET__CV29o_Vp__"